import { Box, BoxProps, Button, Flex, Heading } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useClientsListQuery } from 'generated/graphql';
import { Link } from 'react-router-dom';
import ClientListItem from './ClientListItem';

function ClientList(props: BoxProps) {
  const { loading, data } = useClientsListQuery();

  if (loading) return null;

  return (
    <Box {...props} borderRight="1px" borderColor="gray.200" pr={3}>
      <Flex justify="space-between" align="center">
        <Heading as="h2">Clients</Heading>
        <Button as={Link} to="new" variant="ghost">
          <FontAwesomeIcon icon={['fal', 'user-plus']} size="lg" />
        </Button>
      </Flex>
      <Box mt={4}>
        {data?.clients.edges.map(
          ({ node: client }) => client && <ClientListItem key={client.id} {...client} />
        )}
      </Box>
    </Box>
  );
}

export default ClientList;
